import React, { useEffect, useRef } from 'react';

const CursorEffect = () => {
    const cursorRef = useRef(null);
    const posRef = useRef({ x: 0, y: 0 });
    const rafRef = useRef(null);

    useEffect(() => {
        let isActive = true;

        const handleMouseMove = (e) => {
            if (!isActive) return;
            posRef.current = { x: e.clientX, y: e.clientY };
        };

        const updateCursor = () => {
            if (!isActive || !cursorRef.current) return;

            // Update cursor position
            cursorRef.current.style.left = `${posRef.current.x}px`;
            cursorRef.current.style.top = `${posRef.current.y}px`;

            // Continue the animation loop
            rafRef.current = requestAnimationFrame(updateCursor);
        };

        // Start listening and animating
        window.addEventListener('mousemove', handleMouseMove, { passive: true });
        rafRef.current = requestAnimationFrame(updateCursor);

        return () => {
            isActive = false;
            window.removeEventListener('mousemove', handleMouseMove);
            if (rafRef.current) {
                cancelAnimationFrame(rafRef.current);
            }
        };
    }, []);

    return (
        <div
            ref={cursorRef}
            className="pointer-events-none fixed z-50"
            style={{
                transform: 'translate(-50%, -50%)',
                width: '400px',
                height: '400px',
                background: 'radial-gradient(circle, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0.1) 30%, transparent 70%)',
                mixBlendMode: 'screen',
                willChange: 'left, top',
            }}
        />
    );
};

export default CursorEffect;
